import { CommunitySubscriptionInfo } from 'types';

type SubscriptionUsageSource = {
  info?: CommunitySubscriptionInfo | null;
} | null;

export const getUsedMembersCount = (
  subscription?: SubscriptionUsageSource,
): number => Number(subscription?.info?.users ?? 0);

/** Active subscription slots used (matches backend postCommunity limit check). */
export const getUsedActiveCommunitiesCount = (
  subscription?: SubscriptionUsageSource,
  ownedCommunitiesCount = 0,
): number =>
  Math.max(
    Number(
      subscription?.info?.activeCommunities ??
        subscription?.info?.communities ??
        0,
    ),
    ownedCommunitiesCount,
  );

type MatrixCommunity = {
  users?: Array<{ id?: string | null }> | null;
};

export const isUserInCommunityMatrix = (
  matrix: MatrixCommunity[] | null | undefined,
  userId: string,
): boolean =>
  Boolean(
    matrix?.some((community) =>
      community.users?.some((user) => user?.id === userId),
    ),
  );
